import {
  Component,
  Input,
  Inject,
  OnDestroy,
  OnInit,
  Output,
  EventEmitter,
  DOCUMENT,
  inject,
  DestroyRef, signal
} from '@angular/core';
import { MenuService } from './menu.service';
import { MenuModel } from '../../../app-shared/models/menu.model';
import { Subject } from 'rxjs';

import { Router } from '@angular/router';
import { SupplierOutletSettingsModel } from 'src/app/app-shared/models/supplier-outlet.model';
import { takeUntil } from 'rxjs';
import {AuthService, CustomFunctions, MainUserService, RoleUser} from "../../../app-shared";
import {CatalogService} from "../../../catalog/catalog.service";
import {ObjectForeSearch} from "../../../catalog/models/search.model";
import {SearchService} from "../../../app-shared/services/search-service";
import {UserNotificationService} from "../../user-notification/user-notification.service";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    standalone: false
})
export class MenuComponent implements OnInit {
  @Input() mobile: boolean;
  @Input() disableMenuClick: boolean;
  @Input() isHasPromo: boolean;

  public isBusinessAdmin = signal<boolean>(false);

  public mainMenu: Array<MenuModel>;
  openMobileMenu: boolean;
  public supplierOutletSettings = new Array<SupplierOutletSettingsModel>();
  notificationCounter: number;
  private readonly destroyRef = inject(DestroyRef);

  private readonly mainUserService = inject(MainUserService);

  constructor(
    private menuService: MenuService,
    private catalogService: CatalogService,
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private authService: AuthService,
    private searchService: SearchService,
    private userNotificationService: UserNotificationService,
  ) {
    this.mainMenu = menuService.mainMenu;
  }

  ngOnInit(){
    this.supplierOutletSettings = this.menuService.getSupplierOutletSettings();
    this.catalogService.changeSuppierAndOutlet
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((selectedUserSuppliersAndOutlets) => {
      this.supplierOutletSettings = this.menuService.getSupplierOutletSettings();
    });
    this.userNotificationService.newNotificationsCounter
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(count => {
      this.notificationCounter = count;
    });
    this.isBusinessAdmin.set(
      this.mainUserService.getUserData().role === RoleUser.SuperBusinessAdmin ||
      this.mainUserService.getUserData().role === RoleUser.BusinessAdmin
    );
  }

  getSettingValue(settingName: string): string | undefined {
    const setting = this.supplierOutletSettings.find(s => s.settingName === settingName);
    return setting ? setting.settingValue : undefined;
  }

  toggleMobileMenu() {
    this.mainMenu = this.menuService.mainMenu.filter((item) => {
      if (item.router === '/promo') item.hidden = !this.isHasPromo;
      return !item.hidden
    });
    this.openMobileMenu = !this.openMobileMenu;
  }

  navigateFormMenu(item: MenuModel) {
    this.openMobileMenu = false;
    this.clearSearch();
    if (CustomFunctions.checkIfNumeric(item.id)) {
      const dataModel = [{ plType: item.id}];
      sessionStorage.setItem('filterForPrice', JSON.stringify(dataModel));
      const searchModel = {
        objectForeSearch: ObjectForeSearch.IsProductName,
        values: [''],
      };
      if (this.router.url.includes('/catalog')) {
        this.catalogService.getProducts(false, {
          searchModel: searchModel,
          skip: 0,
        })
        this.router.navigate(['catalog'],  {
          queryParams: {promoId: null, outletId: null, supplierId: null},
          queryParamsHandling: 'merge'
        });
      } else {
        this.router.navigate(['/catalog']);
      }
      return;
    }
    this.router.navigate([item.router]);
  }

  closeMenuMore(){
    this.openMobileMenu = false;
  }
  toggleMenu() {
    this.mainMenu = this.menuService.mainMenu;
  }

  logout() {
    this.authService.logoutUser().subscribe({
      next: () => {
        this.router.navigate(['/start']).then(() => location.reload());
      },
      error: () => {
      },
    });
  }

  clearSearch() {
    if (this.searchService.search) {
      this.searchService.search = '';
      this.searchService.disabled = false;
      this.searchService.lgSearchForDesktop = false;
    }
  }
}
